export default __webpack_public_path__ + "static/media/Coat_of_arms_of_Malaysia.3d350fe4.png";